/**
 * Slice 3 — Pure language-resolution helper.
 *
 * Decides the initial UI language on client boot / user hydration.
 *   1. If the authenticated user profile has a supported language → use it.
 *   2. Else if localStorage has a supported language → use it.
 *   3. Else fall back to "en".
 *
 * Kept as a pure ES module so the React I18nContext can import it AND a
 * Node-only smoke test can require the sibling .cjs shim without pulling
 * React into the test process. This mirrors the pattern already used in
 * /app/frontend/src/lib/api.js + api.node-shim.cjs.
 */
export const SUPPORTED_LANGUAGES = ["en", "ar"];
export const DEFAULT_LANGUAGE = "en";

export function resolveInitialLang({ userLang, storedLang } = {}) {
  if (typeof userLang === "string" && SUPPORTED_LANGUAGES.includes(userLang)) {
    return userLang;
  }
  if (typeof storedLang === "string" && SUPPORTED_LANGUAGES.includes(storedLang)) {
    return storedLang;
  }
  return DEFAULT_LANGUAGE;
}
